var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckBlur(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_35918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.93 23 1 18.07 1 12C1 5.93 5.93 1 12 1C18.07 1 23 5.93 23 12C23 18.07 18.07 23 12 23ZM12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16C10.74 16 10.49 15.9 10.29 15.71L7.79 13.21C7.4 12.82 7.4 12.19 7.79 11.8C8.18 11.41 8.81 11.41 9.2 11.8L10.99 13.59L15.78 8.80001C16.17 8.41001 16.8 8.41001 17.19 8.80001C17.58 9.19001 17.58 9.82001 17.19 10.21L11.69 15.71C11.49 15.91 11.24 16 10.98 16H11Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_35918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckBlur);
export default __webpack_public_path__ + "static/media/icon-check-blur.31c37db69f15bb8fb93927d088c16a32.svg";
export { ForwardRef as ReactComponent };